export const EnglishData = [
    { 
      heading: "AI Inspection Tool Pilot",
      atpSection: {
        introMessage: {
          quote: "We're considering an AI vehicle inspection tool to revolutionize how we inspect vehicles. Your participation in this pilot is invaluable as we lead the way in leveraging technology to better serve our customers.",
          author: {
            name: "Antonio Ward",
            designation: "General Manager - Finished Vehicles",
            photo: '/Assets/images/photo.jpg',
          }
        },
        introVideoTitle: "Pilot Intro"
      },
      purposeSection: {
        heading: "Purpose of the pilot",
        description: [
          "By leveraging VASCOR’s mobile inspection technology, customers gain access to industry-leading expertise in identifying repetitive damage patterns and utilizing AI to detect damage and securement issues in Finished Vehicles.",
          "Over the course of a 12-week pilot, participants will receive detailed analytics comparing AI and human inspection capture rates, insights into recurring damage trends, and enhanced documentation to support more efficient damage claim processing.",
          "This pilot is being conducted to improve damage detection accuracy, streamline claims processing, and reduce repeat issues by leveraging AI-driven insights.",
          "Close collaboration between local ramp operators and VASCOR inspectors is essential to the pilot’s success. Following onboarding and training, customers will receive bi-weekly performance updates along with access to the AI inspection portal for real-time review of pilot metrics."
        ],
        taskHeading: "Getting Started",
        tasks: [
          "Attend the pilot kickoff session with Global Operations",
          "Complete onboarding and VASCOR mobile inspection training",
          "Begin AI inspections using the VASCOR app",
          "Take comprehensive images of the entire vehicle during each inspection",
          "Review the completed AI analysis and identify securement and finish issues",
          "Participate in bi-weekly pilot reviews with VASCOR",
          "Share feedback and escalate any issues or questions to the support team"
        ],
        timelineHeading : "Pilot Timeline",
        timelineItems: [
          {
            label: 'Week 1',
            content: 'Kickoff meeting with VASCOR & Global Operations',
          },
          {
            label: 'Week 2',
            content: 'Completion of onboarding and training',
          },
          {
            label: 'Weeks 3–12',
            content: [
              'AI inspections live at pilot locations',
              'Ongoing support and guidance',
              'Bi-weekly metrics review and performance analysis',
              'Continuous feedback loop and refinement of inspection processes',
            ],
          },
        ]
      },
      inspectionSection: {
        heading: "Inspection Training: How to perform an inspection with the app?",
        downloadManual: "Download Manual",
        relatedVideosTitle: "Check out our 30 seconds tutorials here:",
        relatedVideos: [
          {
            poster: 'video-01_create-new-inspection.png',
            video: "video-01_create-new-inspection.mp4",
            title: "1. Start a New Rail Inspection:",
            description: "How to log in, select “New Inspection,” allow permissions, and choose a workflow.",
            time: "0m24s"
          },
          {
            poster: 'video-02_enter-rail-details.png',
            video: "video-02_enter-rail-details.mp4",
            title: "2. Set Up Rail Details:",
            description: "Enter ID, number of cars, level, deck, track, and car type.",
            time: "0m24s"
          },
          {
            poster: 'video-03_load-factor-details.png',
            video: "video-03_load-factor-details.mp4",
            title: "3. Configure Load Factor & Vehicle Info:",
            description: "Input load factor, body type, VIN position, and wheel securement.",
            time: "0m16s"
          },
          {
            poster: 'video-04_ai-guide-strap-images.png',
            video: "video-04_ai-guide-strap-images.mp4",
            title: "4. AI Guide: Strap Images:",
            description: "Scan VIN and capture strap, wheel, and securement images.",
            time: "0m26s"
          },
          {
            poster: 'video-05_ai-guide-2nd-car-images.png',
            video: "video-05_ai-guide-2nd-car-images.mp4",
            title: "5. AI Guide: Second Car:",
            description: "Scan VIN and capture images of the next car’s selected side.",
            time: "0m30s"
          },
          {
            poster: 'video-06_ai-guide-other-side.png',
            video: "video-06_ai-guide-other-side.mp4",
            title: "6. AI Guide: Other Side:",
            description: "Capture the opposite side, then proceed to damage details.",
            time: "0m20s"
          },
          {
            poster: 'video-07_a-chock-info-and-ai-guide.png',
            video: "video-07_a-chock-info-and-ai-guide.mp4",
            title: "7. Chock Inspections & AI - Guide:",
            description: "Scan VIN and use stencil guidance to capture wheel images.",
            time: "0m39s"
          },
          {
            poster: 'video-08_inspection-detail-screen.png',
            video: "video-08_inspection-detail-screen.mp4",
            title: "8. Inspection Detail Screen:",
            description: "Access car data and captured images in detailed screens.",
            time: "0m57s"
          },
          {
            poster: 'video-09_two-rail-cars-inspection.png',
            video: "video-09_two-rail-cars-inspection.mp4",
            title: "9. Inspecting Two Rail Cars:",
            description: "Enter details and capture images one side at a time for each car.",
            time: "0m57s"
          },
          {
            poster: 'video-10_two-rail-cars-images-2nd-rail-car-details.png',
            video: "video-10_two-rail-cars-images-2nd-rail-car-details.mp4",
            title: "10. Capture the Second Rail Car:",
            description: "After finishing the first, scan VIN and capture the second car’s right side.",
            time: "0m57s"
          }
        ]  
      },
      helpSection: {
        heading: "We are here to help 24/7",
        chatHeading: "Chat with us",
        emailHeading: "Write us an email",
        chat: {
          intercom: "Intercom",
          whatsapp: "+502-570-3238",
          weChat: "WeChat",
          emailAddress: "contact@focalx.ai"
        },
        formHeading: "Drop us a line and leave your email",       
        form: {
          nameFiled: "Enter name",
          emailField: "Enter email",
          commentField: "Enter message",
          buttonText: "Submit",
        }
      },
      faqSection: {
        heading: "FAQ'S",
        accordionItems: [
          {
            accordianTitle: "Do the images need to fit the stencils?",
            accordianContent: ["No, they do not. Do your best and the closer to the car you take the picture the better. But the stencils are there simply to orient you on which image you should be taking."]
          },
          {
            accordianTitle: "How long does it take to get my results?",
            accordianContent: ["Once all images of the vehicle have been uploaded results should be in your inbox in no more than 30 minutes. This is because this is a pilot and it's the first week. The more you use the app the more it learns and the quicker it gets."]
          },
          {
            accordianTitle: "What do these 1, 2… 5 mean?",
            accordianContent: [
              { code: 1, description: 'LESS THAN & INCLUDING 1"', metric: 'Less than 3 cm' },
              { code: 2, description: 'OVER 1" UP TO & INCLUDING 3"', metric: '3 cm up to 8 cm' },
              { code: 3, description: 'OVER 3" UP TO & INCLUDING 6"', metric: '8 cm up to 15 cm' },
              { code: 4, description: 'OVER 6" UP TO & INCLUDING 12"', metric: '15 cm up to 30 cm' },
              { code: 5, description: 'OVER 12"', metric: '30 cm & over' },
              { code: 6, description: 'MISSING', metric: 'No measurement' }
            ]
          },
          {
            accordianTitle: "Does the car have to be cleaned before appraising?",
            accordianContent: ["Not necessarily. The system will detect damages even if the car is not clean. But it is not magic, so if the human eye cannot see the damage and the damage cannot be seen in the photo the Ai cannot detect it."]
          },
          {
            accordianTitle: "Do I need to take all the images?",
            accordianContent: ["Yes, for the system to perform its analysis all images need to be taken and uploaded to guarantee a standardized and thorough appraisal report."]
          },
          {
            accordianTitle: "Will any of the customer's information be shared?",
            accordianContent: ["No, they will not. No names or customer information is being shared in this pilot and none of the data generated is being used for any commercial purpose aside from VASCOR and you evaluating the performance of this tool."]
          },
          {
            accordianTitle: "What do I do if I see a discrepancy or have a problem with the app?",
            accordianContent: ["Make sure to contact support, they will guide you through a resolution. But don't forget to also note it in your post-appraisal survey. The more details you can provide the better."]
          }          
        ]
      },
      downloadSection: {
        content: {
          downloadNow: "Download now",
          autoInspection: "Auto Inspection",
          description: "Find it on App Store or Google Play by searching for it or scanning the QR code below.",    
        }
      },
      footer: "© VASCOR. All rights Reserved.",
      lockScreen: {
        title: "Enter PIN to Access",
        buttonText: "Verify",
      },
    }
];